import React from 'react'
import TriviaPage from '../pages/TriviaPage'

function Trivia() {
  return (
    <TriviaPage/>
  )
}

export default Trivia